module.exports = __webpack_public_path__ + "img/man_color.750c6f56.png";